/**
 * What each ROLE audience is called beside its name — "Controller (service
 * role)" — wherever a share is named: the Share dialog's list and the share
 * badge's tooltip.
 *
 * A role's name alone reads as a person's, and the two role catalogs can hold
 * the same name, so a role is never named without its kind. One map, so the
 * two places cannot come to call the same thing by different words.
 *
 * Takes a plain string: a bundle already deployed can be sent an audience newer
 * than itself, and that is not a role this build can describe. `undefined` for
 * it, for a person, and for everyone.
 */
const ROLE_KINDS: ReadonlyMap<string, string> = new Map([
  ['role', 'system role'],
  ['service_role', 'service role'],
]);

export function roleKind(audience: string): string | undefined {
  return ROLE_KINDS.get(audience);
}
